export const LOAD_STATUS = Object.freeze({
    NOT_STARTED: 0,
    PENDING: 1,
    COMPLETE: 2,
} as const);

export type LoadStatus = (typeof LOAD_STATUS)[keyof typeof LOAD_STATUS];
